module.exports = __webpack_public_path__ + "img/sucess.fb0eb302.svg";